import { customFetch } from "@/client/custom-fetch";

import {
  TSaleDetailsResponse,
  TSaleReportFilters,
  TSalesReportResponse,
} from "./reports.types";

const API_BASE = "/sales";

export const reportsApi = {
  // Obter relatório de vendas com filtros
  getSalesReport: (filters: TSaleReportFilters): Promise<TSalesReportResponse> => {
    // Monta os objetos de filtros e paginação
    const filtersObj: any = {};
    const paginationObj: any = {
      page: filters.page || 1,
      limit: filters.limit || 20,
    };

    if (filters.sale_id) filtersObj.sale_id = filters.sale_id;
    if (filters.status) filtersObj.status = filters.status;
    if (filters.partner) filtersObj.partner = filters.partner;
    if (filters.customer_name) filtersObj.customer_name = filters.customer_name;
    if (filters.customer_cpf) filtersObj.customer_cpf = filters.customer_cpf;
    
    // Valores de venda (min/max)
    if (filters.value_sale) {
      filtersObj.value_sale = {};
      if (filters.value_sale.min) filtersObj.value_sale.min = filters.value_sale.min;
      if (filters.value_sale.max) filtersObj.value_sale.max = filters.value_sale.max;
    }
    
    // Datas
    if (filters.sale_date) {
      filtersObj.sale_date = {};
      if (filters.sale_date.start_date) filtersObj.sale_date.start_date = filters.sale_date.start_date;
      if (filters.sale_date.end_date) filtersObj.sale_date.end_date = filters.sale_date.end_date;
    }
    
    // Constrói a URL com query parameters
    const queryParams = new URLSearchParams();
    queryParams.append("filters", JSON.stringify(filtersObj));
    queryParams.append("pagination", JSON.stringify(paginationObj));
    
    const url = `${API_BASE}/report?${queryParams.toString()}`;
    
    return customFetch<TSalesReportResponse>(url, {
      method: "GET",
    });
  },

  // Obter detalhes de uma venda específica
  getSaleDetails: (
    transactionSearchId: string
  ): Promise<TSaleDetailsResponse> => {
    return customFetch<TSaleDetailsResponse>(
      `${API_BASE}/report/${transactionSearchId}`,
      {
        method: "GET",
      }
    );
  },

  // Obter vendas pendentes
  getPendingSales: (): Promise<any[]> => {
    return customFetch<any[]>(`${API_BASE}/pending`, {
      method: "GET",
    });
  },

  // Integrar venda
  integrateSale: (
    externalId: string,
    infinisisSaleId: number
  ): Promise<void> => {
    return customFetch<void>(`${API_BASE}/integrate/${externalId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ infinisis_sale_id: infinisisSaleId }),
    });
  },

  // Marcar venda como falha na integração
  markIntegrationFailed: (
    externalId: string,
    errors: Array<{ error_code: number; error_message: string }>
  ): Promise<void> => {
    return customFetch<void>(
      `${API_BASE}/integration-failed/${externalId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ errors }),
      }
    );
  },
};
